<template lang="html">
  <div id="SpHelpPage">
    <h1 class="helpH1" style="margin-top: 10px">座席予約表を見る</h1>
    <p style="color: red;" class="caption cap1">予約・変更・削除の締め切りは前日22時です（翌週月曜の座席予約は土曜22時までとなっております）</p>
    <p style="tcolor: red;" class="caption cap1">上記時刻を過ぎて予約をしたい場合は、究進塾事務局(info@kyushinjuku.com)へご連絡ください</p>
    <h2 class="helpH2">予約をする</h2>
    <ol class="helpOl" style="color: #5B5B5B;">
      <li>予約したい時刻と、予約したい教室がクロスするマスをクリック</li>
      <li>「開始時間」「終了時間」「授業の種類（通常・通常初回・体験・短期・短期初回）」「生徒のお名前」「先生のお名前」「配布物（有り・無し）」「連絡事項（必要であれば記入）」を記入</li>
      <li>「予約する」をクリック</li>
    </ol>
    <p class="caption cap2">同時間帯・同教室で月末まで予約したい場合は、「月末まで毎週予約する」にチェックを入れてください</p>

    <div class="notification">
      <p style="color: red;" class="caption">※予約時に、「生徒のお名前」に担当生徒の氏名が表示されない場合※</p>
      <p class="caption">先生と生徒の紐づけが未完了です</p>
      <p class="caption">恐れ入りますが、究進塾事務局(info@kyushinjuku.com)へご連絡ください。また、臨時的に下記手順でご予約をお願い致します。</p>
      <ol class="helpOl" style="left; margin-left: 40px;">
        <li>「授業の種類」で「短期」を選択</li>
        <li>「生徒のお名前」を “直接” 入力</li>
      </ol>
    </div>

    <h2 class="helpH2">予約を変更する</h2>
    <ol class="helpOl">
      <li>変更したい予約をクリック</li>
      <li>ポップアップの最下部「編集する」をクリック</li>
      <li>予約を編集</li>
      <li>「編集を完了する」をクリック</li>
    </ol>

    <h2 class="helpH2">予約を削除する</h2>
    <ol class="helpOl">
      <li>削除したい予約をクリック</li>
      <li>ポップアップの最下部「編集する」をクリック</li>
      <li>「予約を削除する」をクリック</li>
    </ol>
    <h1 class="helpH1" style="margin-top: 60px;">振替依頼</h1>
    <h2 class="helpH2">振替依頼をする場合</h2>
    <ol class="helpOl">
      <li>座席予約表へログイン後、画面左上の「振替を依頼する」をクリック</li>
      <li>画面の指示に従い、入力を進める</li>
      <ol>
        <li>①振替を希望する授業をリストから選択</li>
        <li>②振替候補日時を選択</li>
        <li>③振替を希望する理由を入力</li>
        <li>（講師のみ、④振替後の授業の情報を入力）</li>
      </ol>
      <li>入力項目を確認し、「振替依頼をする」ボタンをクリック</li>
      <li>または、「戻って修正する」ボタンをクリック</li>
      <li>完了画面を確認し、「座席表トップへ」をクリック</li>
    </ol>
    <div class="box27">
        <span class="box-title">振替依頼をしたあとは・・・</span>
        <p>24時間以内に振替の承認・不承認の結果がメールで届きます。<br>
          承認された場合は、そのまま振替後の日時に教室にお越しください。<br>
          不承認された場合は、承認者から別の振替候補日時が提案されますので、再度振替依頼を行ってください。</p>
    </div>
    <h2 class="helpH2">振替依頼をされた場合</h2>
    <ol class="helpOl">
      <li>「〇〇様からの授業振替依頼が届きました」または「〇〇先生からの授業振替依頼が届きました」という件名のメールが届く</li>
      <li>メール内のURLをクリック</li>
      <li>画面の指示に従い、入力を進める</li>
      <ol>
        <li style="font-weight: bold; margin-top: 5px;">【承認する場合】</li>
        <ol>
          <li>①振替候補日時からご都合の良い日時を選択</li>
          <li>　（講師のみ振替後の授業の情報を指定）</li>
          <li>②振替後の授業を予約する座席を選択</li>
          <li>③入力項目を確認し、「振替を確定する」をクリック</li>
          <li>　または、「戻って修正する」ボタンをクリック</li>
          <li>④完了画面を確認し、「座席表トップへ」をクリック</li>
        </ol><br>
        <li style="font-weight: bold; margin-top: 5px;">【不承認する場合】</li>
        <ol>
          <li>①「振替を不承認する」にチェックを入れる</li>
          <li>　（講師のみ振替後の授業の情報を指定）</li>
          <li>②他の振替候補日時を入力</li>
          <li>③入力項目を確認し、「振替依頼を不承認する」をクリック</li>
          <li>　または、「戻って修正する」ボタンをクリック</li>
          <li>④完了画面を確認し、「座席表」をクリック</li>
        </ol>
      </ol>
    </ol>
    <div class="box27">
        <span class="box-title">承認/不承認をしたあとは・・・</span>
        <p>承認・不承認の結果がメールで依頼者に届きます。<br>
        承認した場合は、そのまま振替後の日時に教室にお越しください。<br>
        不承認した場合は、依頼者から別の振替候補日時が提案されますので、再度承認/不承認を行ってください。</p>
    </div>

    <h1 class="helpH1">ヘルプ</h1>
    <p class="caption cap1">本画面です</p>

    <h1 class="helpH1">ユーザ情報</h1>
    <p class="caption cap1">パスワードおよびユーザ名（ID）の変更が出来ます</p>
    <div class="notification">
      <p style="color: red;" class="caption">※ご注意ください※</p>
      <p class="caption">初回設定以外のパスワードに変更される場合は、<span style="color: red">事務局では変更内容を確認出来ません</span></p>
      <p class="caption">変更後のパスワードは各個人で保管いただきますようお願い申し上げます</p>
    </div>

    <h1 class="helpH1" style="margin-top: 60px;">ログアウト</h1>
    <p style="text-align: left; margin-left: 40px; font-size: 14px; color: #5B5B5B; margin-top: 10px;" class="cap1">ログアウトが出来ます</p>
    <p style="text-align: left; margin-left: 40px; font-size: 14px; color: red; margin-bottom: 100px;" class="cap1">究進塾のPCで座席予約表を操作される場合は、セキュリティ上必ずログアウトしていただきますようお願い致します</p>
  </div>
</template>

<script>
export default {
  name: 'SpHelpPage'
}
</script>

<style scoped>
.notification{
  width: 80%;
  margin: auto;
}
.box27 {
    position: relative;
    margin: 2em 0;
    padding: 0.5em 1em;
    border: solid 3px #62c1ce;
}
.box27 .box-title {
    position: absolute;
    display: inline-block;
    top: -27px;
    left: -3px;
    padding: 0 9px;
    height: 25px;
    line-height: 25px;
    vertical-align: middle;
    font-size: 17px;
    background: #62c1ce;
    color: #ffffff;
    font-weight: bold;
    border-radius: 5px 5px 0 0;
}
.box27 p {
    margin: 0;
    padding: 0;
}
</style>



// WEBPACK FOOTER //
// SpHelpPage.vue?14ec20d1